export const LEFT_MENU_SECTIONS = Object.freeze({
    SECTORES: 'sectores',
    MEDIOS: 'medios',
    PLANES_OPERACIONES: 'planesOperaciones',
    PERIMETROS: 'perimetros',
    IMAGENES_SATELITE: 'imagenesSatelite',
});
export const MAX_STORED_INCIDENTS = 5;
export function isLeftMenuSection(value) {
    return Object.values(LEFT_MENU_SECTIONS).includes(value);
}
export function createExpandedSections() {
    return Object.fromEntries(Object.values(LEFT_MENU_SECTIONS).map((section) => [section, true]));
}
